import React from 'react';

const RefundPolicy = () => {
    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-white">Refund Policy</h1>
                    <p className="text-indigo-100 mt-2">Last updated: {new Date().getFullYear()}</p>
                </div>
                
                <div className="p-6 md:p-8 space-y-6">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">1. Digital Products Policy</h2>
                        <p className="text-gray-600 leading-relaxed">
                            All study materials, PDFs, and digital content purchased on Abha Publication are 
                            non-refundable. Due to the digital nature of our products, once accessed or downloaded, 
                            they cannot be returned.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">2. Subscription Plans</h2>
                        <p className="text-gray-600 leading-relaxed">
                            Subscription payments are non-refundable. You may cancel your subscription at any time, 
                            but no refunds will be provided for the unused portion of your subscription period.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">3. Technical Issues</h2>
                        <p className="text-gray-600 leading-relaxed">
                            If you experience technical issues that prevent you from accessing purchased content, 
                            please contact our support team within 7 days of purchase. We will work to resolve the 
                            issue promptly. If we cannot resolve the issue, we may issue a refund at our discretion.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">4. Duplicate Charges</h2>
                        <p className="text-gray-600 leading-relaxed">
                            In the event of a duplicate charge, please contact us immediately. We will verify the 
                            transaction and issue a refund for the duplicate amount within 7-10 business days.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">5. How to Request a Refund</h2>
                        <p className="text-gray-600 leading-relaxed">
                            To request a refund for eligible issues, please contact us at:
                            <span className="block mt-2 text-indigo-600">abhapublicationindia@gmail.com</span>
                            Please include your order number, email address used for purchase, and a detailed 
                            explanation of the issue.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">6. Processing Time</h2>
                        <p className="text-gray-600 leading-relaxed">
                            Approved refunds will be processed within 7-10 business days. The refund will be credited 
                            to your original payment method. Depending on your bank, it may take additional time 
                            for the refund to appear in your account.
                        </p>
                    </div>

                    <div>
                        <h2 className="text-xl font-bold text-gray-800 mb-3">7. Contact Us</h2>
                        <p className="text-gray-600 leading-relaxed">
                            For any questions regarding this Refund Policy, please contact us at:
                            <span className="block mt-2 text-indigo-600">abhapublicationindia@gmail.com</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;